export default __webpack_public_path__ + "static/media/logo-lockup.24504413.svg";